import { render, staticRenderFns } from "./ItemFilterInterestFilter.vue?vue&type=template&id=3755f89a&scoped=true"
import script from "./ItemFilterInterestFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilterInterestFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3755f89a",
  null
  
)

export default component.exports